import { Design } from '@/types';
import { DesignsActionTypes, DesignsFetchAction } from '../types';

export const storeDesignAction = (payload: Design): DesignsFetchAction => ({
  type: DesignsActionTypes.DESIGNS_FETCH,
  payload,
});
